module.exports = __webpack_public_path__ + "static/media/icon-table.d9a7b6ec.png";